module.exports = __webpack_public_path__ + "static/FSG-S-119a8dba09dd2e07d573bbefa1a5f143.jpg";